import { render, staticRenderFns } from "./DepositRequest.vue?vue&type=template&id=2dfa401c&"
import script from "./DepositRequest.vue?vue&type=script&lang=js&"
export * from "./DepositRequest.vue?vue&type=script&lang=js&"
import style0 from "./DepositRequest.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DepositRequest.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports